export enum ProvedorCobrancaNome {
  ND = 0,
  CIELO = 1,
  IUGU = 2
}